//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.CutPatternBuilder.js";
import "../no/SectionList.js";
import "../CAM/CAM.AreaMillingNonSteepContainment.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.AreaMillingSteepContainment.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
import "../no/ObjectList.js";
let d=[[[0,"AmAddPasses",1,0],[0,"AmAutoPatCenter",1,0],[0,"AmCutPattern",1,0],[0,"AmCutRegionStartEnum",1,0],[0,"AmCutTraversal",1,0],[0,"AmPocketDir",1,0],[0,"AmSteepOption",1,0],[0,"CutAngle",0,"CAM.CutAngle",0],[1,"CutPatternBuilder",0,"CAM.CutPatternBuilder",0],[0,"DmAmRegionCon",1,0],[1,"FromCurveList",0,"SectionList",0],[1,"NonSteepCutting",0,"CAM.AreaMillingNonSteepContainment",0],[0,"OrderRegionsType",1,0],[0,"PatternCenterPoint",1,"Point",0],[0,"ProfilePass",1,0],[0,"RecognizeFlatOption",1,0],[1,"SteepAngle",0,"CAM.InheritableDoubleBuilder",0],[1,"SteepCutting",0,"CAM.AreaMillingSteepContainment",0],[1,"SteepOverlapAngle",0,"CAM.InheritableDoubleBuilder",0],[1,"SteepOverlapDistance",0,"CAM.InheritableToolDepBuilder",0],[0,"SteepOverlapOption",1,0],[0,"SteepOverlapType",1,0],[1,"StepoverBuilder",0,"CAM.StepoverBuilder",0]],[],[]];
SPLM.CAM.DmAmBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DmAmBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DmAmBuilder.AmCutPatternTypes = Object.freeze({
    "FollowPeriphery" : "FollowPeriphery", "Profile" : "Profile", "Sep1" : "Sep1", "ParallelLines" : "ParallelLines", "RadialLines" : "RadialLines", "ConcArcs" : "ConcArcs"});

SPLM.CAM.DmAmBuilder.AmCutTraversalTypes = Object.freeze({
    "ZigZag" : "ZigZag", "ZigZagWithLifts" : "ZigZagWithLifts", "Zig" : "Zig", "Contour" : "Contour", "Stepover" : "Stepover"});

SPLM.CAM.DmAmBuilder.AmPocketDirTypes = Object.freeze({
    "Outward" : "Outward", "Inward" : "Inward"});

SPLM.CAM.DmAmBuilder.AmCustomStartTypes = Object.freeze({
    "Custom" : "Custom", "Automatic" : "Automatic"});

SPLM.CAM.DmAmBuilder.SteepOptTypes = Object.freeze({
    "SteepContainNone" : "SteepContainNone", "NonSteepNonDirectional" : "NonSteepNonDirectional", "SteepDirectional" : "SteepDirectional", "SteepAndNonsteep" : "SteepAndNonsteep", "Steep" : "Steep"});

SPLM.CAM.DmAmBuilder.SteepOverlapOptTypes = Object.freeze({
    "None" : "None", "Angle" : "Angle", "Distance" : "Distance"});

SPLM.CAM.DmAmBuilder.OrderRegionsOptTypes = Object.freeze({
    "Default" : "Default", "Topdown" : "Topdown", "TopdownDepthFirst" : "TopdownDepthFirst"});

SPLM.CAM.DmAmBuilder.AutoPatCenterTypes = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify"});

export default SPLM;